interface Props {
  className?: string;
}

export function Skeleton({ className }: Props) {
  return (
    <span
      aria-hidden="true"
      className={'inline-block animate-pulse rounded-md bg-line/60 ' + (className ?? 'h-4 w-24')}
    />
  );
}
